export function all(state) {
  return state.resources.map((resource) => {
    return new state.modelClass(resource)
  })
}

export function find(state) {
  return (id) => {
    return new state.modelClass(
      state.resources.find((resource) => String(resource.id) === String(id))
    )
  }
}

export function findBy(state) {
  return (attributes) => {
    return new state.modelClass(
      state.resources.find((record) =>
        Object.keys(attributes).every((key) => record[key] === attributes[key])
      )
    )
  }
}

export function filterBy(state) {
  return (attributes) => {
    return state.resources.filter((record) =>
      Object.keys(attributes).every((key) => record[key] === attributes[key])
    ).map((resource) => {
      return new state.modelClass(resource)
    })
  }
}
